/* eslint-disable react-hooks/exhaustive-deps */
import React, {Fragment} from 'react';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import {connectHits, connectStateResults} from 'react-instantsearch-dom';
import Skeleton from '@material-ui/lab/Skeleton';
import ItemProduct from './makeComponents/components/ItemProduct';
import { Box, Typography } from '@material-ui/core';

const StateResults = ({searching, hasHits, small}) => {
  return (
    searching &&
    !hasHits && (
      <React.Fragment>
        {[1, 2, 3, 4, 6, 7, 8].map((i) => (
          <Grid item xs={6} md={3} lg={small ? 3 : 2} key={i}>
            <Skeleton variant="rect" height={180} />
            <Skeleton
              width="60%"
              style={{margin: '0 auto', display: 'block'}}
            />
            <Skeleton
              width="30%"
              style={{margin: '0 auto', display: 'block'}}
            />
          </Grid>
        ))}
      </React.Fragment>
    )
  );
};

const ProductStateResults = connectStateResults(StateResults);

const ProductList = ({hits = [], small}) => {
  return (
    <Fragment>
      <Grid container spacing={2}>
        <ProductStateResults hasHits={hits.length > 0} small={small} />
        {hits.map((product, i) => (
          <Grid key={i} item xs={6} md={3} lg={small ? 3 : 2}>
            <ItemProduct data={product} />
          </Grid>
        ))}
        {hits.length === 0 && (
          <Box justifyContent="center" mt={4} display="flex" style={{margin: '20px auto'}}>
            <Typography variant='body2' style={{textAlign: 'center'}}>No se han encontrado productos.</Typography>
          </Box>
        )}
      </Grid>
    </Fragment>
  );
};

ProductList.propTypes = {
  small: PropTypes.bool,
  disableMoreButton: PropTypes.bool,
};

export default connectHits(ProductList);
